// extracted by mini-css-extract-plugin
export default {"root":"ColorSwatchLabel_root__-ueoa","swatch":"ColorSwatchLabel_swatch__bLHNq"};